<template>
    <div class="cat">
        <transition-group name="fade-list">
            <template v-for="(item, item_key) in this_catalog">
                <template v-if="item.SUB_ARTICLES && item.SUB_ARTICLES.length">
                    <div
                        :key="item_key"
                        :class="['folder', item.expanded?'expanded':'', level === 1 ? 'general':'', currentArticle === item.ID ? 'active' : '']"
                        @click="setKeyInTo(item, 'expanded', !item.expanded);articleAction(item.ID), $emit('catClick')"
                    >
                        <span>{{ item.TITLE }}</span>
                    </div>
                    <template v-if="item.SUB_ARTICLES && item.expanded">
                        <div
                            :key="item_key+'_sub'"
                            class="group"
                        >
                            <catalog
                                v-model:catalog="item.SUB_ARTICLES"
                                :current-article="currentArticle"
                                :level="level + 1"
                                :article-action="articleAction"
                            />
                        </div>
                    </template>
                </template>
                <template v-else>
                    <div
                        :key="item_key+'_'+item.ID+'_article'"
                        :class="['article', currentArticle === item.ID ? 'active' : '']"
                        @click.stop="articleAction(item.ID, false, item), $emit('catClick')"
                    >
                        {{ item.TITLE }}
                    </div>
                </template>
            </template>
        </transition-group>
    </div>
</template>
<script>
    import catalog from '../components/catalog';

    export default {
        name: 'Catalog',
        components: {
            catalog
        },
        props: {
            catalog: {
                type: Object,
                default: () => {}
            },
            level: {
                type: Number,
                default: 0
            },
            currentArticle: {
                type: [Boolean, String],
                default: false,
            },
            articleAction: {
                type: Function,
                default: () => {}
            }
        },
        emits: ['catClick', 'update:catalog'],
        data () {
            return {}
        },
        computed: {
            this_catalog: {
                get: function () {
                    return this.catalog
                },
                set: function (newValue) {
                    this.$emit('update:catalog', newValue)
                }
            }
        },
        methods: {
        }
    }
</script>
<style scoped>
    .cat .folder {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        align-content: center;
        margin-bottom: 8px;
        cursor: pointer;
        white-space: nowrap;
        position: relative;
        transition: .3s ease-in-out;
        border-radius: 4px;
        padding: 8px 10px;
    }

    .cat .folder span {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        width: 100%;
        font-size: 15px;
    }

    .cat .folder.active span {
    }
    .cat .folder.active {
        background-color: var(--button-secondary);
    }
    .cat .folder:hover {
        background-color: var(--button-additional-hover);
    }

    .cat .folder.general span {
        font-size: 19px;
    }

    .cat .folder:before {
        content:'';
        margin-right: 10px;
        display: block;
        transform: rotate(0deg);
        transition: transform 0.2s ease;
        pointer-events: none;
        background-image:url('../assets/images/arrow_right.svg');
        background-position: center;
        background-repeat: no-repeat;
        background-size: contain;
        width: 10px;
        min-width: 10px;
        height: 10px;
    }

    .cat .folder.expanded:before {
        transform: rotate(90deg);
    }

    .cat .group {
        padding-left: 30px;
        margin-bottom: 12px;
    }

    .cat .article {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 10px;
        cursor: pointer;
        padding: 8px 10px;
        font-size: 15px;
        transition: .3s ease-in-out background;
        border-radius: 4px;
    }
    .cat .article:hover {
        background-color: var(--button-additional-hover);
    }
    .cat .article.active {
        background-color: var(--button-secondary);
    }

    @media only screen and (max-width: 1024px) {
        .folder, .cat {
            user-select: none;
        }
    }
</style>
